module.exports = __webpack_public_path__ + "static/media/Filled-down-arrow-chartreuse.23fda7f2.svg";